var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card",class:_vm.classes,style:({'width': _vm.width, 'height': _vm.height})},[_c('img',{staticClass:"image-card__mask",attrs:{"src":_vm.image,"alt":""}}),_c('div',{staticClass:"image-card__content",class:{'pl-5': _vm.bordered }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }